module.exports = __webpack_public_path__ + "static/album-img3-d78dd106f5bb93594c0d94fbf81a4655.jpg";